export const ContactSearch = {
    job_levels: {
        brd: false,
        chf: false,
        vp: false,
        dir: false,
        mgr: false,
        stf: false/* ,
        other: false */
    },
    job_departments: {
        fnad: false,
        hr: false,
        it_is: false,
        lgl: false,
        mrkt: false,
        ops: false,
        prc: false,
        enrd: false,
        sale: false,
        other: false
    },
    job_sub_departments: [],
    required_fields: {
        address: false,
        phone: false,
        direct_phone: false,
        any_mobile: false,
        // personal_mobile: false,
        // work_mobile: false,
        personal_email: false,
        linkedin_url: false,
        job_title: false
    },
    rankings: {
        fast100: false,
        fast500: false,
        federalcontractors: false,
        forbesglobal2000: false,
        fortune500: false,
        fortune1000: false,
        fundingRoundA: false,
        fundingRoundB: false,
        fundingRoundC: false,
        fundingRoundD: false,
        fundingRoundSeed: false,
        inc5000: false,
        linkedinTopStartups2021: false,
        managedServiceProviders: false,
        publicCompanies: false,
        saas1000: false,
        valueAddedResellers: false
    },
    tiers: 'human',
    company_location_zipcodes: [],
    company_location_zipcodes_distance: 0,
    contact_location_zipcodes:[],
    contact_location_zipcodes_distance: 0,
    company_min_size: '',
    company_max_size: '',
    is_international: 0,
    location_country_codes: ['US'],
    location_types: [],
    contact_revenue_max_identifier: 'M',
    contact_revenue_min_identifier: 'M',
    gte_last_modified_date: '',
    matchOnJobHistory: true,
    accuracy_tier_contact: 'EV',
};
